export const form2023Gql = `... on landingPageContent2023_form_BlockType {
  typeHandle
  form {
    id
  }
}`;
